// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.not-allowed {\n\tcursor: not-allowed !important;\n}\n.not-allowed:focus {\n\tbackground-color: rgba(109, 114, 120, 0.05);\n\tcolor: #383838;\n\tborder-color: #383838;\n}\n.btnFamily,\n.btnActionFamily {\n\theight: 46px;\n\tfloat: right;\n\twidth: 100%;\n}\n@media (max-width: 576px) {\n.btnFamily {\n\t\twidth: 50%;\n}\n.btnActionFamily {\n\t\twidth: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
